module.exports = __webpack_public_path__ + "img/report-icon.d839c190.svg";